const SMALL_WORDS = new Set([
  'a',
  'an',
  'and',
  'for',
  'of',
  'or',
  'the',
  'vs',
  '&',
]);

function lettersOf(value: string): string[] {
  // Keep combining marks with their base character so NFD titles such as
  // `E\u0301quipe` still produce an accented initial instead of a bare `E`.
  const letters: string[] = [];
  for (const match of value.matchAll(/(?:\p{L}|\p{N})\p{M}*/gu)) {
    letters.push(match[0]);
  }
  return letters;
}

/**
 * Compact label for a sidebar section when the rail is icon-collapsed.
 *
 * Multi-word titles become initials (Accounts Payable → AP). Three-or-more
 * word titles use the first and last significant words so a qualifier still
 * distinguishes (Ship and Debit Admin → SA). Single words use the first two
 * letters (Rebates → RE).
 */
export function navGroupMonogram(title: string): string {
  const words = title
    .trim()
    .split(/[\s/]+/)
    .filter((word) => word.length > 0 && !SMALL_WORDS.has(word.toLowerCase()));

  if (words.length >= 2) {
    const firstWord = words[0];
    const lastWord = words.length >= 3 ? words[words.length - 1] : words[1];
    const first = firstWord ? lettersOf(firstWord)[0] : undefined;
    const last = lastWord ? lettersOf(lastWord)[0] : undefined;
    if (first && last) {
      return `${first}${last}`.toUpperCase();
    }
  }

  const source = words[0] ?? title;
  const letters = lettersOf(source);
  const first = letters[0];
  const second = letters[1];
  if (first && second) {
    return `${first}${second}`.toUpperCase();
  }
  if (first) {
    return first.toUpperCase();
  }
  return '?';
}
